import { useState } from "react";
import { companyInfo } from "../data/siteData";

const mapQuery = encodeURIComponent("1910 Turner Dr Unit C, Houston, TX 77093");
const mapEmbedUrl = `https://www.google.com/maps?q=${mapQuery}&output=embed`;
const mapOpenUrl = `https://www.google.com/maps/search/?api=1&query=${mapQuery}`;

export default function ContactPage() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
    event.currentTarget.reset();
  };

  return (
    <div data-testid="contact-page" className="page-shell page-offset">
      <section data-testid="contact-header-section" className="section-block">
        <div className="container-shell two-column">
          <div>
            <p data-testid="contact-eyebrow" className="eyebrow">Contact</p>
            <h1 data-testid="contact-heading" className="section-title">Bring us your steel scope. We deliver engineered execution.</h1>
          </div>
          <div data-testid="contact-company-details" className="contact-card">
            <p data-testid="contact-company-name" className="contact-title">{companyInfo.name}</p>
    <div
  className="contact-owner"
  style={{
    fontFamily: "inherit",  // same as company name
    fontSize: "16px",        // slightly bigger than address (usually 14px)
    fontWeight: "500",       // medium weight, matches professional style
    color: "#ffffff",        // visible on blue background
    marginBottom: "8px",
    lineHeight: "1.2",
  }}
>
  <div>Alex Wayne</div>
  <div>Owner</div>
</div>
            <p data-testid="contact-company-address-line-1">{companyInfo.addressLine1}</p>
            <p data-testid="contact-company-address-line-2">{companyInfo.addressLine2}</p>
            <p data-testid="contact-company-country">{companyInfo.country}</p>
            <a data-testid="contact-phone-link" href="tel:+17134667322" className="text-link">{companyInfo.phone}</a>
            <a data-testid="contact-email-link" href={`mailto:${companyInfo.email}`} className="text-link">{companyInfo.email}</a>
          </div>
        </div>
      </section>

      <section id="quote-form" data-testid="contact-form-section" className="section-block muted-bg">
        <div className="container-shell form-container">
          <h2 data-testid="contact-form-heading" className="section-title">Request a Quote</h2>
          <form data-testid="contact-form" className="form-grid" onSubmit={handleSubmit}>
            <input data-testid="contact-name-input" name="name" required type="text" placeholder="Full Name" className="text-input" />
            <input data-testid="contact-company-input" name="company" required type="text" placeholder="Company Name" className="text-input" />
            <input data-testid="contact-email-input" name="email" required type="email" placeholder="Email Address" className="text-input" />
            <input data-testid="contact-phone-input" name="phone" required type="tel" placeholder="Phone Number" className="text-input" />
            <textarea data-testid="contact-project-details-input" name="project_details" required rows="4" placeholder="Project scope, timeline, and location" className="text-input textarea" />
            <button data-testid="contact-submit-button" type="submit" className="primary-btn">
              Submit Inquiry
            </button>
          </form>
          {submitted && (
            <div data-testid="contact-success-message" className="success-note">
              Thank you for contacting Wayne Iron Works. We will respond shortly.
            </div>
          )}
        </div>
      </section>

      <section data-testid="contact-map-section" className="section-block">
        <div className="container-shell">
          <h2 data-testid="contact-map-heading" className="section-title">Facility Location</h2>
          <div data-testid="contact-map-container" className="map-frame">
            <iframe
              data-testid="contact-map-iframe"
              src={mapEmbedUrl}
              title="Wayne Iron Works Houston Map"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <a
            data-testid="contact-open-map-link"
            href={mapOpenUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="secondary-btn"
          >
            Open Map
          </a>
        </div>
      </section>
    </div>
  );
}
